import $ from "jquery";


$(function(){
  $(document).on("click", ".func-date-range-icon-focuser", function(e){
    e.preventDefault();
    const toggler = $(this);
    toggler.closest('.func-date-range-wrapper').find(".func-date-range-input").focus();
  });
})


// WEBPACK FOOTER //
// ./src/utilities/dateRangeInputIconFocuser/index.js